import { render, staticRenderFns } from "./filterCustomer.vue?vue&type=template&id=52cda998&scoped=true&"
import script from "./filterCustomer.vue?vue&type=script&lang=js&"
export * from "./filterCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cda998",
  null
  
)

export default component.exports